import { TriUserService } from "@onetakesolutions/cargogo-contract-web/TriUserService_dubbo";
import { createPromiseClient } from "@apachedubbo/dubbo";
import transport from "./transport";

const client = createPromiseClient(TriUserService, transport, {
  serviceGroup: "dubbo",
  serviceVersion: "1.0.0",
});

export default client;
